import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Divider, Fixed, Flex, Heading, Modal, Text, Label } from 'rebass';
import styled from 'styled-components';
import { overflow, PvButtonOutline } from 'styles/CustomComponents';
import DataTable from 'components/datatable';
import { PvBox } from 'styles/CustomComponents';

const Overflow = styled(Modal)`
  ${overflow}
`;

class DriverCardModal extends React.Component {

  render() {
    const {
      hideModal,
      applicant
    } = this.props;

    const rows = applicant.lessonEntries;
    const drivingRows = rows.filter(row => row.lesson.lessonType === 'DRIVING').map((row, index) => {
      const start = moment(row.lessonStartTime);
      const end = moment(row.lessonEndTime);
      const duration = (() => {
        if (start.isValid() && end.isValid()) {
          const difference = end.diff(start);
          if (difference > 0) {
            const duration = moment.duration(difference);
            return duration.hours() + ':' + (duration.minutes() < 10 ? 0 : '') + duration.minutes();
          }
        }
        return '';
      })();
      const topicsCell = row.drivingTopics.map(drivingTopic => drivingTopic.code + ' ' + drivingTopic.topic).join(', ');

      return {
        lessonIndex: index + 1,
        lessonTime: start.format('DD.MM.YYYY H:mm') + ' - ' + end.format('H:mm'),
        lessonDuration: duration,
        training: row.additionalInfo,
        supervisor: row.supervisor,
        topics: topicsCell,
        guidedTraining: '',
        independentTraining: '',
      };
    });
    const course = "DUMMY COURSE"//applicant.course.courseNumber + ' / ' + applicant.course.courseYear + ' / ' + applicant.course.courseUnit;

    const driverExamInformation = applicant.exams.map(exam => {
      return (
        <Flex flexWrap='wrap' alignItems='flex-end' key={exam.examClass} width={[1]}>
          <PvBox display='inline-block' px={2} pb={3} width={[1 / 3]} minHeight={60}>
            <Label mb={2} h={10}>
              <Translate value='driver_card.exam_class' />
            </Label>
            <Text>{exam.examClass}</Text>
          </PvBox>
          <PvBox display='inline-block' px={2} pb={3} width={[1 / 3]} minHeight={60}>
            <Label mb={2} h={10}>
              <Translate value='driver_card.theory_exam_count' />
            </Label>
            <Text>{exam.theoryExamCount}</Text>
          </PvBox>
          <PvBox display='inline-block' px={2} pb={3} width={[1 / 3]} minHeight={60}>
            <Label mb={2} h={10}>
              <Translate value='driver_card.driving_exam_count' />
            </Label>
            <Text>{exam.drivingExamCount}</Text>
          </PvBox>
        </Flex>
      );
    });

    return (
      <React.Fragment>
        <Fixed
          onClick={() => hideModal()}
          top={0}
          right={0}
          bottom={0}
          left={0}
        />
        <Overflow overflow={['auto', 'visible', 'visible']} p={3} width={['90%', '90%', '90%', '90%', '110vh']}>
          <Heading mb={3} fontSize='19px'>
            <Translate value='driver_card.title' />
          </Heading>
          <Divider my={2} w={1} borderBottom={2} borderColor='grays.1' />
          <Heading mb={3} fontSize='19px'><Translate value='driver_card.person' /></Heading>
          <PvBox my={3}>
            <Flex flexWrap='wrap' alignItems='flex-end'>
              <PvBox display='inline-block' px={2} pb={3} width={[1 / 5]} minHeight={60}>
                <Label mb={2}>
                  <Translate value='driver_card.trafi_id' />
                </Label>
                <Text>{applicant.trafiId}</Text>
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} width={[1 / 5]} minHeight={60}>
                <Label mb={2}>
                  <Translate value='driver_card.last_name' />
                </Label>
                <Text>{applicant.lastName}</Text>
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} width={[1 / 5]} minHeight={60}>
                <Label mb={2}>
                  <Translate value='driver_card.first_names' />
                </Label>
                <Text>{applicant.firstNames}</Text>
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} width={[1 / 5]} minHeight={60}>
                <Label mb={2} h={10}>
                  <Translate value='driver_card.civil_driving_licence' />
                </Label>
                <Text>{applicant.civilDrivingLicenses}</Text>
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} width={[1 / 5]} minHeight={60}>
                <Label mb={2} h={10}>
                  <Translate value='driver_card.course' />
                </Label>
                <Text>{course}</Text>
              </PvBox>
            </Flex>
          </PvBox>

          {applicant.medicalInformation && applicant.medicalInformation.medicalCertificate &&
            <div>
              <Divider my={2} w={1} borderBottom={2} borderColor='grays.1' />
              <Heading mb={3} fontSize='19px'><Translate value='driver_card.medical_certificate' /></Heading>
              <PvBox my={3}>
                <Flex flexWrap='wrap' alignItems='flex-end'>
                  <PvBox display='inline-block' px={2} pb={3} width={[1 / 2]} minHeight={60}>
                    <Label mb={2} h={10}>
                      <Translate value='driver_card.current_medical_state' />
                    </Label>
                    <Text>{applicant.medicalInformation.medicalCertificate}</Text>
                  </PvBox>
                  <PvBox display='inline-block' px={2} pb={3} width={[1 / 2]} minHeight={60}>
                    <Label mb={2} h={10}>
                      <Translate value='driver_card.current_medical_state_date' />
                    </Label>
                    <Text>{moment(applicant.medicalInformation.medicalCertificateDate).format('D.M.YYYY')}</Text>
                  </PvBox>
                </Flex>
              </PvBox>
            </div>
          }

          {driverExamInformation.length > 0 &&
            <div>
              <Divider my={2} w={1} borderBottom={2} borderColor='grays.1' />
              <Heading mb={3} fontSize='19px'><Translate value='driver_card.driver_exam_information' /></Heading>
              <PvBox my={3}>
                <Flex flexWrap='wrap' alignItems='flex-end'>
                  {driverExamInformation}
                </Flex>
              </PvBox>
            </div>
          }

          <Divider my={2} w={1} borderBottom={2} borderColor='grays.1' />
          <Heading mb={3} fontSize='19px'><Translate value='driver_card.driving_training' /></Heading>
          <Flex flexWrap='wrap'>
            <DataTable
              rowKey='lessonIndex'
              rows={drivingRows}
              tableHeight={'28vh'}
              tableType='DRIVER_CARD' />
          </Flex>
          <Divider my={2} w={1} borderBottom={2} borderColor='grays.1' />
          <Text py={2} textAlign='center'>
            <PvButtonOutline
              width='12em'
              my={1}
              ml={2}
              onClick={() => hideModal()}>
              <Translate value='app.cancel' />
            </PvButtonOutline>
          </Text>
        </Overflow>
      </React.Fragment>
    );
  }
};

DriverCardModal.propTypes = {
  applicantId: PropTypes.number,
  hideModal: PropTypes.func,
  supervisor: PropTypes.string,
};

export default DriverCardModal;


// WEBPACK FOOTER //
// ./src/components/modal/DriverCardModal.jsx